// extracted by mini-css-extract-plugin
module.exports = {"Event":"Event--2723C","Highlight":"Highlight--1rm-l"};